// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__kxZkA","calendarButtons":"ClockData_calendarButtons__1kdO2"};